import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VerificationService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
  }

  OkycOtpGen(KycDetail: any) {
    return this.http.post<any>(environment.API_URL + `Aadhar/OkycOtpGen`,
      this.session.SetClass(KycDetail)
    ).pipe(map(response => {
      return response;
    }));
  }

  OKYCOTPVerify(KycDetail: any) {
    return this.http.post<any>(environment.API_URL + `Aadharverify/OKYCOTPVerify`,
      this.session.SetClass(KycDetail)
    ).pipe(map(response => {
      return response;
    }));
  }

  VerifyPan(KycDetail: any) {
    return this.http.post<any>(environment.API_URL + `Pan/VerifyPan`,
      this.session.SetClass(KycDetail)
    ).pipe(map(response => {
      return response;
    }));
  }

  VerifyBank(KycDetail: any) {
    return this.http.post<any>(environment.API_URL + `Bank/VerifyBank`,
      this.session.SetClass(KycDetail)
    ).pipe(map(response => {
      return response;
    }));
  }

  EmpEmailOtpVerify(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmpEmailOtp/Verify`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  EmpMobileOtpVerify(Detail: any) {
    return this.http.post<any>(environment.API_URL + `EmpMobileOtp/Verify`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  DigiDigiLocker_init(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Digi/DigiLocker_init`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  DigiResponseDigiLocker_Response(Detail: any) {
    return this.http.post<any>(environment.API_URL + `DigiResponse/DigiLocker_Response`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
